import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store.ts';
import { OrganizationWithRole } from '../../api.ts';

interface OrganizationState {
  organizations: OrganizationWithRole[];
  currentOrganization: OrganizationWithRole | null;
  organizationsLoaded: boolean;
}

const initialState: OrganizationState = {
  organizations: [],
  currentOrganization: null,
  organizationsLoaded: false,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizations(state, action: PayloadAction<OrganizationWithRole[]>) {
      state.organizations = action.payload;
      state.organizationsLoaded = true;

      // Auto-select default organization if not already set
      if (!state.currentOrganization && action.payload.length > 0) {
        const defaultOrg = action.payload.find(org => org.is_default);
        state.currentOrganization = defaultOrg || action.payload[0];
      }
    },
    setCurrentOrganization(state, action: PayloadAction<OrganizationWithRole | null>) {
      state.currentOrganization = action.payload;

      // Store in localStorage for persistence
      if (action.payload && action.payload.id !== undefined) {
        localStorage.setItem('currentOrganizationId', action.payload.id.toString());
      } else {
        localStorage.removeItem('currentOrganizationId');
      }
    },
    addOrganization(state, action: PayloadAction<OrganizationWithRole>) {
      state.organizations.push(action.payload);
    },
  },
});

export const {
  setOrganizations,
  setCurrentOrganization,
  addOrganization,
} = organizationSlice.actions;

export const selectOrganizations = (state: RootState) => state.organization.organizations;
export const selectCurrentOrganization = (state: RootState) => state.organization.currentOrganization;
export const selectOrganizationsLoaded = (state: RootState) => state.organization.organizationsLoaded;

export default organizationSlice.reducer;
